import '@/components/keenicons/assets/duotone/style.css';
import '@/components/keenicons/assets/outline/style.css';
import '@/components/keenicons/assets/filled/style.css';
import '@/components/keenicons/assets/solid/style.css';
import './css/styles.css';

import axios from 'axios';
import ReactDOM from 'react-dom/client';

import {App} from './App';
import {setupAxios} from './auth';
import {ProvidersWrapper} from './providers';
import React from 'react';

/**
 * Inject interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

/**Sentry.init({
 dsn: "https://a18d811173487257151999692669a901@o409472.ingest.us.sentry.io/4508320962379777",
 integrations: [
 Sentry.browserTracingIntegration(),
 Sentry.replayIntegration(),
 ],
 // Tracing
 tracesSampleRate: 1.0, //  Capture 100% of the transactions
 // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
 tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
 // Session Replay
 replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
 replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
 });**/

// Boolean flag to enable or disable StrictMode
const isStrictModeEnabled = false;

setupAxios(axios);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    isStrictModeEnabled ? (
        <React.StrictMode>
            <ProvidersWrapper>
                <App/>
            </ProvidersWrapper>
        </React.StrictMode>
    ) : (
        <ProvidersWrapper>
            <App/>
        </ProvidersWrapper>
    )
);
